export * from '../_generated/locale';
